export const membershipTranslation = {
  en: {
    Memberships: "Memberships",
    "Add Membership": "Add Membership",
    "Edit Membership": "Edit Membership",
    Delete: "Delete",
    "Search by title": "Search by title...",
    "Title (EN)": "Title (EN)",
    "Title (AR)": "Title (AR)",
    Title: "Title",
    Logo: "Logo",
    "Description (EN)": "Description (EN)",
    "Description (AR)": "Description (AR)",
    Status: "Status",
    Active: "Active",
    Inactive: "Inactive",
    Icons: "Icons",
    Link: "Link",
    "Are you sure you want to delete membership '{{name}}'?":
      "Are you sure you want to delete membership '{{name}}'?",
    "This action cannot be undone.": "This action cannot be undone.",
    Home: "Home",
    Settings: "Settings",
    Landing: "Landing",
    "Created At": "Created At",
    Actions: "Actions",
    "Update Membership": "Update Membership",
    "Add New Membership": "Add New Membership",
    Cancel: "Cancel",
  },
  ar: {
    Memberships: "العضويات",
    "Add Membership": "إضافة عضوية",
    "Edit Membership": "تعديل العضوية",
    Delete: "حذف",
    "Search by title": "البحث حسب العنوان...",
    "Title (EN)": "العنوان (EN)",
    "Title (AR)": "العنوان (AR)",
    Title: "العنوان",
    Logo: "الشعار",
    "Description (EN)": "الوصف (EN)",
    "Description (AR)": "الوصف (AR)",
    Status: "الحالة",
    Active: "نشط",
    Inactive: "غير نشط",
    Icons: "الأيقونات",
    Link: "الرابط",
    "Are you sure you want to delete membership '{{name}}'?":
      "هل أنت متأكد أنك تريد حذف العضوية '{{name}}'؟",
    "This action cannot be undone.": "لا يمكن التراجع عن هذا الإجراء.",
    Home: "الصفحة الرئيسية",
    Settings: "الإعدادات",
    Landing: "الموقع التعريفي",
    "Created At": "تاريخ الإنشاء",
    Actions: "الإجراءات",
    "Update Membership": "تحديث العضوية",
    "Add New Membership": "إضافة عضوية جديدة",
    Cancel: "إلغاء",
  },
};
